<style lang="scss">
  @import "@/assets/scss/vuexy/pages/List.scss";
</style>

<template>
  <div>
    <vs-button @click="createUser()" color="rgb(0, 195, 195)" type="filled" class="create-user-button mb-2 float-right">{{$t('Labels.AddUser')}}</vs-button>
    <div class="vx-row mb-5">
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <label class="font-bold align-middle mr-2">{{$t('Labels.OrderBy')}}</label><v-select @input="getResponse" class="align-middle inline-block" :options="columnOrders" v-model="filters.byColumn" :reduce="v => v.value"  :clearable="false"/>
      </div>
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <vs-button size="small" @click="filterOrders('ASC')"  type="flat" color="grey" class="align-middle inline-block ml-2" :class="{'bg-primary': filters.byOrder == 'ASC'}">
          <iconBase iconName="filter_asc" :width="18" :height="18" iconColor="#626262" class="align-middle"><iconFilterAsc/></iconBase>
        </vs-button>
        <vs-button  size="small" @click="filterOrders('DESC')"  type="flat" color="grey" class="align-middle inline-block ml-2" :class="{'bg-primary': filters.byOrder != 'ASC'}">
          <iconBase iconName="filter_desc" :width="18" :height="18" iconColor="#626262" class="align-middle"><iconFilterDesc/></iconBase>
        </vs-button>
      </div>
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <label class="font-bold align-middle mr-2">{{$t('Labels.ByPage')}}</label><v-select @input="getResponse" class="align-middle inline-block" :options="byPage" v-model="filters.limit" :reduce="v => v.value"  :clearable="false" />
      </div>
    </div>
    <div id="data-list-list-view" class="data-list-container mt-2 px-">
      <vs-table  ref="table" :data="response">
        <template>
          <tbody>
          <tr :key="index" @click="editUser(item.uuid)" class="tr-values vs-table--tr tr-table-state-null selected" v-for="(item, index) in response">
              <listItem
                :value=" item.first_name + ' ' +item.last_name"
                :description="$tc('Labels.User',1)"
                img="alias"
              ></listItem>
              <listItem
                :value=" item.email"
                :description="$t('Email')"
                img="alias"
              ></listItem>
              <listItem
                :value="(item.type === 'MA'?$t('Labels.Admin'):$t('Labels.Reader'))"
                :description="$t('Labels.UserType')"
                img="alias"
              ></listItem>
              <listItem
                :value="item.created_at"
                :description="$t('Labels.Date')"
                img="alias"
              ></listItem>
              <listItem
                :value="(item.active === 'Y'?$t('Labels.Active'):$t('Labels.Inactive'))"
                :description="$t('Labels.Status')"
                img="alias"
              ></listItem>

          </tr>
          </tbody>
        </template>
      </vs-table>
      <vs-pagination v-if="response" :max="5" :total="totalPages" v-model="currentx"></vs-pagination>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { request } from '@/request.js'
import listItem from '@/components/listItem/listItem.vue'
import iconBase from '@/components/icons/iconBase'
import iconFilterAsc from '@/components/icons/iconFilterAsc'
import iconFilterDesc from '@/components/icons/iconFilterDesc'

export default {
  name: 'list',
  components: {
    'v-select': vSelect,
    listItem,
    iconBase,
    iconFilterAsc,
    iconFilterDesc
  },
  data () {
    return {
      isMounted: false,
      response: [],
      currentx: 1,
      totalPages: 0,
      columnOrders: [
        { label: this.$t('Labels.Name'), value: 'first_name' },
        { label: this.$t('Labels.Date'), value: 'created_at' }
      ],
      byPage: [
        { label: 20, value: 20 },
        { label: 50, value: 50 },
        { label: 75, value: 75 },
        { label: 100, value: 100 }
      ],
      filters: {
        limit: 20,
        offset: 0,
        byColumn: 'created_at',
        byOrder: 'ASC'
      }
    }
  },

  methods: {
    async getResponse () {
      const params = {
        url: 'modelo/users',
        method: 'GET',
        params: this.filters
      }

      await request(params).then(res => {
        this.response = res.data.data.rows
        console.log(this.response)
        this.setPages(res.data.data.count)
        this.isMounted = true
      }).catch(() => {
        this.response = []
        this.setPages(0)
      }).finally(() => {
        this.$vs.loading.close()
      })
    },

    editUser (uuid) {
      window.location.href = `/edit-user/${uuid}`
    },

    createUser () {
      window.location.href = '/create-user/'
    },
    setPages (total) {
      this.totalPages = Math.ceil(total / this.filters.limit)
    },
    doFilter () {
      if (this.currentx !== 1) { this.currentx = 1 } else { this.getResponse() }
    },
    filterOrders (param) {
      this.filters.byOrder = param
      this.getResponse()
    }
  },

  created () {
    this.getResponse()
  },
  watch: {
    currentx (val) {
      this.filters.offset = (val - 1) * this.filters.limit
      this.getResponse()
    },
    byColumn (val) {
      this.filters.byColumn = val
      this.currentx = 1
    }
  }
}
</script>
